import { inject, Injectable, NgZone } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ToasterService } from '@core/toaster/toaster.service';
import { TypeSafeModalManagerService } from 'morgana';
import { filter } from 'rxjs/operators';
import { ManageUpdatesSubscriptionService } from '@header/services/manage-updates-subscription.service';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({
	providedIn: 'root',
})
export class FeatureFlagToastService {
	private toasterService = inject(ToasterService);
	private featureFlagService = inject(FeatureFlagService);
	authenticationService = inject(AuthenticationService);
	private manageUpdatesSubscriptionService = inject(ManageUpdatesSubscriptionService);
	private router = inject(Router);
	private zone = inject(NgZone);

	subscribe(typeSafeModalManagerService: TypeSafeModalManagerService) {
		this.featureFlagService.getNewFeatureFlagCount().subscribe((featureFlagCount) => {
			if (featureFlagCount > 0) {
				this.zone.run(() => {
					this.toasterService.showDefaultNotificationToast({
						title: `${featureFlagCount} New Update(s) Available`,
						buttons: [
							{
								model: {
									content: 'More Info',
									cssClass: 'btn btn-link',
								},
								click: () => {
									this.openModal(typeSafeModalManagerService);
								},
							},
						],
					});
				});
			}

			this.router.events.pipe(filter(
				event => event instanceof NavigationStart))
				.subscribe((event: NavigationStart) => {
					if (event.url.indexOf('home') === -1) {
						this.clearToasts();
					}
				});
		});
	}

	openModal(typeSafeModalManagerService: TypeSafeModalManagerService) {
		this.manageUpdatesSubscriptionService.openManageUpdateModal(typeSafeModalManagerService);
	}

	clearToasts() {
		this.toasterService.hideDefaultNotificationToast();
	}
}
